module.exports = __webpack_public_path__ + "img/bohu-index.8be6b492.jpg";